/*@ngInject*/
const OrganizationBrowserActionUtil = function ($rootScope, $state, configurationMediator, coreConstant, modalUtil, localization, loadingBarHandler, fileExportUtil) {

    localization.getTranslationByKey('organizationBrowser').then((translations) => {

        this.createOrganization = function (organizationType) {
            let promise = configurationMediator.createNewOrganization(organizationType).then(function (organization) {
                $state.go('configuration.manageOrganization', {organizationId: organization.id, organizationType: organizationType});
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        };

        this.importCarrierLOAs = function (file, isMga) {
            let promise;
            loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'importCarrierLOAs.loadingBar'));
            promise =  configurationMediator.importCarrierLOAs(file, isMga).then(function (result) {
                let resultSplits = _.split(result, '\n'),
                    successfulImports = parseInt(_.trim(resultSplits[1].substring(_.indexOf(resultSplits[1], '-') + 1))),
                    failedImports = parseInt(_.trim(resultSplits[2].substring(_.indexOf(resultSplits[2], '-') + 1))),
                    failedReasons,
                    config,
                    summary;

                if (failedImports === 0) {
                    loadingBarHandler.concludeNotificationLoadingBar(_.replace(_.get(translations, 'importCarrierLOAs.' + (successfulImports === 1 ? 'successMessageSingular' : 'successMessagePlural')), '{0}', successfulImports));
                } else {
                    loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);

                    // Remove the first 4 entries of the resultSplits array, which is everything except the failed reasons,
                    // then join those reasons back together to display in the client:
                    resultSplits.splice(0, 4);
                    failedReasons = _.join(resultSplits, '\n');

                    summary = _.get(translations, 'importCarrierLOAs.errorModal.summary');
                    summary = _.replace(summary, '{0}', successfulImports);
                    summary = _.replace(summary, '{1}', failedImports);
                    summary = _.replace(summary, '{2}', failedReasons);

                    config = {
                        confirmActionButtonLabel: _.get(translations, 'importCarrierLOAs.errorModal.confirmActionButtonLabel'),
                        summary: summary,
                        title: _.get(translations, 'importCarrierLOAs.errorModal.title')
                    };

                    modalUtil.showGenericConfirm(config);
                }
            }, function () {
                // On Error
                loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        };

        this.exportCarrierLOAs = function (isMga) {
            let promise;
            loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'exportCarrierLOAs.loadingBar'));
            promise = configurationMediator.exportCarrierLOAs(isMga).then(function (result) {
                let filename = 'carrierLOAExport.xml';

                loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'exportCarrierLOAs.successMessage'));

                fileExportUtil.saveAs(result, 'application/xml', filename);
            }, function () {
                // On Error
                loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        };

    });

};

angular.module('ums.configuration')
    .service('organizationBrowserActionUtil', OrganizationBrowserActionUtil);
